import { useEffect } from 'react';

const HelmetTitle = ({ title }) => {
  useEffect(() => {
    document.title = title ? `TSFC | ${title}` : 'TSFC';
  }, [title]);

  return null;
};

export default HelmetTitle;
